import React, { createContext, useContext, useMemo, useState } from "react";

const ChatArtifactContext = createContext(null);

export function ChatArtifactProvider({ children }) {
  const [artifactPanelOpen, setArtifactPanelOpen] = useState(false);
  const value = useMemo(
    () => ({ artifactPanelOpen, setArtifactPanelOpen }),
    [artifactPanelOpen]
  );

  return (
    <ChatArtifactContext.Provider value={value}>{children}</ChatArtifactContext.Provider>
  );
}

export function useChatArtifact() {
  const ctx = useContext(ChatArtifactContext);
  if (!ctx) {
    return {
      artifactPanelOpen: false,
      setArtifactPanelOpen: () => {},
    };
  }
  return ctx;
}
